import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import SearchInput from '../common/SearchInput'
import FilterButton from '../common/buttons/FilterButton'
import FilterSelect from '../common/buttons/FilterSelect'
import { ReactComponent as FilterIcon } from '../../assets/images/common/icons/filter-icon.svg'

import classes from './CoachesHeader.module.scss'

export const FILTERS_BUTTON_ID = 'coachFiltersButton'

const CoachesHeader = ({
  searchText, organizationFilter, activeFilterCount, isFiltersOpen, onSearchChange, onOrganizationChange, onFiltersClick,
}) => {
  const { t } = useTranslation()
  const organizations = useSelector(state => state.organizations.organizations)
  const organizationOptions = organizations.map(o => ({ value: String(o.id), label: o.name }))

  return (
    <header className={classNames(classes.subHeader, 'd-flex align-items-center justify-content-between')}>
      <SearchInput
        className={classes.searchInput}
        placeholder={t('coaches.header.searchPlaceholder')}
        value={searchText}
        onChange={onSearchChange}
      />

      <div className={classNames(classes.filterOptions, 'd-flex align-items-center')}>
        <FilterSelect
          id='organizationFilter'
          value={organizationFilter}
          onChange={onOrganizationChange}
          options={organizationOptions}
          placeholder={t('coaches.header.allOrganizations')}
        />
        <FilterButton
          id={FILTERS_BUTTON_ID}
          icon={<FilterIcon className={`${classes.filterIcon} mr-2`} width={16} height={16} />}
          text={activeFilterCount > 0 ? t('coaches.header.filtersApplied', { count: activeFilterCount }) : t('coaches.header.filtersButton')}
          onClick={onFiltersClick}
          isActive={activeFilterCount > 0 || isFiltersOpen}
        />
      </div>
    </header>
  )
}

CoachesHeader.propTypes = {
  searchText: PropTypes.string.isRequired,
  organizationFilter: PropTypes.string.isRequired,
  activeFilterCount: PropTypes.number.isRequired,
  isFiltersOpen: PropTypes.bool.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onOrganizationChange: PropTypes.func.isRequired,
  onFiltersClick: PropTypes.func.isRequired,
}

export default CoachesHeader
